<template>
  <div id="about">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%;box-shadow: 0px 0px 1px 1px gray;"></div>
    <div class="about-nav">
    </div>
    <!--内容-->
    <div class="main">
      <!--锚点内容-->
      <div class="about-contain">
        <el-row id="1" class="row-bg" style="min-height: 30rem">
          <el-col :span="24">
            <h3 class="about-title">资源下载</h3>
          </el-col>
          <el-col :span="24" class="about-content">
            <div class="uses" style="">
              <el-row :gutter="30">
                <el-col :span="8" v-for="(item,index) in resList" :key="index">
                  <el-col  class="user" style="padding: 10px 0px;margin-bottom: 35px">
                    <a :href="'http://ad.kdslow.com/api/'+item.fileUrl" target="_blank">
                      <el-col :span="24">
                        <el-col :span="24" style="padding: 0px;margin: 0px;margin-top: 5px;font-family: SimHei">
                          <span style="font-size: 20px"> {{item.title}}</span>
                        </el-col>
                        <el-col :span="24" style="font-size: 12px;margin-top: 10px;padding: 0px;font-family: SimHei">{{item.des}}</el-col>
                        <el-col :span="24" style="font-size: 12px;margin-top: 10px;padding: 0px;font-family: SimHei">点击下载</el-col>
                      </el-col></a>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <el-row id="1" class="row-bg">
          <el-col :span="24" class="left">
            <h3 class="about-title">常用地址</h3>
          </el-col>
          <el-col :span="24" class="about-content">
            <div class="uses" style="">
              <el-row :gutter="30">
                <el-col :span="8" v-for="(item,index) in addressList" :key="index">
                  <el-col  class="user" style="padding: 10px 0px;margin-bottom: 35px">
                    <a :href="item.fileUrl" target="_blank">
                      <el-col :span="24">
                        <el-col :span="24" style="padding: 0px;margin: 0px;margin-top: 5px;font-family: SimHei">
                          <span style="font-size: 20px"> {{item.title}}</span>
                        </el-col>
                        <el-col :span="24" style="font-size: 12px;margin-top: 10px;padding: 0px;font-family: SimHei">{{item.des}}</el-col>
                      </el-col></a>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import axios from 'axios'
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      banner: [],
      resList: [],
      addressList: [{
        title: '快点云打印-后台管理',
        des: '管理用户的打印订单',
        fileUrl: 'http://app.kdslow.com:9890'
      }, {
        title: '快点云打印-市场部',
        des: '管理合伙人、运营总监、分组信息',
        fileUrl: 'http://market.kdslow.com'
      }, {
        title: '快点云打印-广告后台',
        des: '管理终端广告、官网信息',
        fileUrl: 'http://ad.kdslow.com'
      }, {
        title: '新世界服务大厅-后台管理',
        des: '记账单位管理-账单查询',
        fileUrl: 'http://tally.kdslow.com'
      }, {
        title: '粉墨大师',
        des: '机器维护教程',
        fileUrl: 'http://ink.kdslow.com'
      }, {
        title: '快递代取',
        des: '代取团队、校区管理',
        fileUrl: 'http://delivery.kdslow.com'
      }]
    }
  },
  created () {
    Api.changeClass = 4
    this.getList()
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    },
    getList () {
      let _this = this
      axios.get(Api.Market_BASE_URL + Api.getResList, {params: { 'size': '100' }}).then((response) => {
        console.log(response)
        _this.resList = response.data.data.records
        console.log(_this.resList)
      }, (response) => {
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    }
  }
}

</script>

<style>
  .uses img{
    width: 100%;
  }
  .user{
    text-align: left;
    /*height: 150px;*/
    /*border-radius: 5px;border: solid black 1px;*/
    box-shadow: 1px 1px 1px 1px gray;
  }
  .nav-content {
    width: 100%;
    height: 80px;
    box-shadow: none;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .block {
    position: relative;
  }

  .el-carousel {
    width: 100%;
    height: 550px;
  }

  .el-carousel img {
    width: 100%;
    height: 100%;
  }

  .is-active .el-carousel__button {
    background-color: #00f1ff;
  }

  .el-carousel__button {
    height: 5px;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .el-carousel__arrow:hover {
    background-color: #cf0631;
  }

  .main {
    width: 1200px;
  }

  .link-content {
    margin: 50px auto;
  }

  .link-content li {
    display: inline-block;
  }

  .link-content li a {
    display: inline-block;
    margin: 0px 20px;
    width: 180px;
    height: 45px;
    line-height: 45px;
    border-radius: 5px;
    color: #fff;
    font-size: 18px;
    background-color: #333333;
  }

  .link-content li a:hover {
    background-color: #fd3434;
  }

  .about-contain {
    margin-top: 30px;
    width: 1060px;
  }

  .about-title {
    width: 100px;
    height: 100px;
    /*border-radius: 50px;*/
    /*color: #fff;*/
    /*background-color: #333333;*/
    line-height: 100px;
    margin-bottom: 30px;
    font-size: 16px;
    margin-left: 10px;
  }

  .about-content {
    margin-bottom: 50px;
  }

  .about-content p {
    font-size: 14px;
    line-height: 30px;
    text-align: left;
    text-indent: 2em;
  }
  .about-content img{
    height: 80px;
    margin: auto;
  }

  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }

  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }
  .team-contain{
    width: 100%;
    height: 350px;
    background-color: #fd3434;
    position: relative;
    margin-bottom: 40px;
  }
  .person-box,.person-box img{
    width: 350px;
    height: 350px !important;
    float: left;
  }
  .team-introduce{
    width: 630px;
    height: 350px;
    background-color: #ddd;
    position: absolute;
    top: 0;
    right: 0;
    padding: 40px 30px 30px 90px;
    text-align: left;
  }
  .team-introduce p{
    font-size: 24px;
    color: #333333;
    margin-bottom: 10px;
  }
  .team-introduce small{
    margin-left: 50px;
    font-size: 18px;
  }
  .team-introduce label{
    background-color: #fff;
    color: #fd3434;
    width: 160px;
    height: 80px;
    font-size: 32px;
    text-align: center;
    line-height: 80px;
    position: absolute;
    top: 20px;
    left: -50px;
    font-weight: bold;
  }
  .team-des{
    width: 100%;
    position: absolute;
    bottom: 20px;
    left: 0;
    text-align: right;
  }
  .team-des span{
    font-size: 24px;
    color: #fff;
    margin: 0px 10px;
  }
  .fixed-about-block{
    width: 100%;
    height: 145px;
    display: none;
  }
  .display-block{
    display: block;
  }
  .fixed-about-nav{
    position: fixed;
    top: 80px;
    left: 0px;
    width: 100%;
    z-index: 999;
    box-shadow:5px 5px 8px -3px rgba(0, 0, 0, 0.1);
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/res.vue